import st from "lib/utils/index";
import { ProductScheduleSlotsRepository } from "lib/repositories/index";
import { createResourceInstance } from "modules/utils/index";
import { dateFormat } from "../common";
import { groupBy, keyBy } from "lodash";
import { ApiService } from "lib/index";
import Axios from "../../../../node_modules/axios/index";

export const INITIALIZE_VIEW = "accommodation/AccommodationCalendarView/INITIALIZE_VIEW";

export const FETCH_SLOTS = "accommodation/AccommodationCalendarView/FETCH_SLOTS";
export const FETCH_SLOTS_START = "accommodation/AccommodationCalendarView/FETCH_SLOTS_START";
export const FETCH_SLOTS_SUCCESS = "accommodation/AccommodationCalendarView/FETCH_SLOTS_SUCCESS";
export const FETCH_SLOTS_FAILURE = "accommodation/AccommodationCalendarView/FETCH_SLOTS_FAILURE";

export const CHANGE_START_DATE = "accommodation/AccommodationCalendarView/CHANGE_START_DATE";
export const SET_DATE_RANGE = "accommodation/AccommodationCalendarView/SET_DATE_RANGE";

export const stateSelector = (state) => state.accommodation.AccommodationCalendarView;

const now = new Date();
const pastDays = 2;
export const displayedDays = 23;

const defaultStartDate = moment(now).subtract(pastDays, "days").format(dateFormat);
const defaultEndDate = getEndDate(defaultStartDate);

const api = ApiService;

export function getEndDate(startDate) {
  return moment(startDate)
    .add(displayedDays - 1, "days")
    .format(dateFormat);
}

const slotsResource = createResourceInstance({
  FETCH: FETCH_SLOTS,
  FETCH_START: FETCH_SLOTS_START,
  FETCH_SUCCESS: FETCH_SLOTS_SUCCESS,
  FETCH_FAILURE: FETCH_SLOTS_FAILURE,
  stateSelector,
  stateKey: "slots",
  getModel: ({ startDate, endDate }, { getState }) => {
    return ProductScheduleSlotsRepository.findAll({
      company_id: getState().auth.company.model.id,
      starts_at_gte: startDate,
      starts_at_lte: endDate,
    });
  },
});

const initialState = {
  slots: slotsResource.initialState,
  startDate: defaultStartDate,
  endDate: defaultEndDate,
};

const reducers = {
  ...slotsResource.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,

  [SET_DATE_RANGE]: (state, { startDate }) => ({
    ...state,
    slots: { model: [] },
    startDate,
    endDate: getEndDate(startDate),
  }),
};

const epics = [
  ...slotsResource.epics,

  (actions$) => actions$.ofType(INITIALIZE_VIEW).mapTo(fetchSlots()),

  (actions$) => actions$.ofType(CHANGE_START_DATE).map(({ startDate }) => setDateRange(startDate)),

  (actions$) => actions$.ofType(CHANGE_START_DATE).mapTo(fetchSlots()),
];

export const { fetch: fetchSlots } = slotsResource.actions;

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export function changeStartDate(startDate) {
  return { type: CHANGE_START_DATE, startDate };
}

export function setDateRange(startDate) {
  return { type: SET_DATE_RANGE, startDate };
}

export function groupSlotsByProductVariantId(slots) {
  const decoratedSlots = slots.map((slot) => ({
    ...slot,
    date: moment(slot.starts_at).format(dateFormat),
    pricings_by_pricing_plan_id: keyBy(slot.product_schedule_slot_pricings, "pricing_plan_id"),
  }));
  const slotsByProductVariantId = groupBy(decoratedSlots, "product_variant_id");
  return Object.keys(slotsByProductVariantId).reduce((obj, pvId) => {
    const pvSlots = slotsByProductVariantId[pvId];
    obj[pvId] = keyBy(pvSlots, "date");
    return obj;
  }, {});
}

export function getProductDetails(selectedProducts) {
  return selectedProducts.map(({ productId, varaintId }) => {
    const url = `${api.apiUrl}/products/${productId}?locale=${api.locale}&current_company_id=${api.currentCompanyId}`;
    return Axios.get(url, {
      headers: {
        common: {
          "X-Api-Version": api.apiVersion,
          "X-Admin-Email": api.currentAdminUserEmail,
          "X-Admin-Token": api.currentAdminUserToken,
        },
      },
    })
      .then((response) => response.data.included)
      .then((data) => {
        return data.map((product) => {
          if (product.uuid === varaintId) {
            return {
              productId: productId,
              varaintId: varaintId,
              default_requires_company_approval: product.attributes.default_requires_company_approval,
              default_total_stock_limit: product.attributes.default_total_stock_limit,
              nb_requires_company_approval: product.attributes.nb_requires_company_approval,
              presented_price: product.attributes.presented_price,
              stock_left: product.attributes.default_total_stock_limit - product.attributes.nb_total_stock_used
            };
          }
        }).filter(item => item !== undefined);
      });
  });
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/accommodation/AccommodationCalendarView/index.js